import React, { FC, memo } from 'react';
import { Button, Input, Space } from 'udesk-ui';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { AddOutlined, IndeterminateCircleOutlined } from '@udesk/icons';
import { TranslateTerminologyItemCreateRequest } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

export interface TemplateProps {
    value?: Pick<TranslateTerminologyItemCreateRequest, 'content' | 'lang'>[];
    onChange?: (v: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    const onLangChange = (idx: number, lang: number) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        lang,
                    };
                }
                return item;
            })
        );
    };

    const onContentChange = (idx: number, content: string) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        content,
                    };
                }
                return item;
            })
        );
    };

    const onDel = (idx: number) => {
        onChange?.(
            value?.filter((_, _idx) => {
                return idx !== _idx;
            })
        );
    };

    const onAdd = () => {
        onChange?.([
            ...(value || []),
            {
                lang: undefined,
                content: undefined,
            },
        ]);
    };

    return (
        <div>
            {value?.map((item, index) => {
                return (
                    <div style={{ marginBottom: 8 }}>
                        <Space>
                            <LanguageSelect
                                value={item?.lang}
                                onChange={(v) => onLangChange(index, v as number)}
                                disabledList={value
                                    .filter((item) => !!item.lang)
                                    .map((item) => item.lang!)}
                            />
                            <Input
                                value={item?.content}
                                onChange={(e) => onContentChange(index, e.target.value)}
                                style={{ width: 200 }}
                                placeholder={/* 请输入该语言的术语名称 */UdeskLocales['current'].pages.semanticIntelligence.smartWordsLibrary.translationTerminology.components.list.index.pleaseEnterATermNameForTheLanguage}
                            />
                            <IndeterminateCircleOutlined onClick={() => onDel(index)} />
                        </Space>
                    </div>
                );
            })}

            <div>
                <Button
                    icon={<AddOutlined />}
                    type="link"
                    style={{ padding: 0 }}
                    onClick={() => onAdd()}
                >{/* 新增其他语言 */}{UdeskLocales['current'].pages.semanticIntelligence.smartWordsLibrary.translationTerminology.components.list.index.addAdditionalLanguages}</Button>
            </div>
        </div>
    );
});

export default Template;
